(() => {
  const $ = (id) => document.getElementById(id);

  // =========================================================
  // 0) Config (hard-coding minimized)
  // =========================================================
  const CONFIG = {
    game: {
      W: 360,
      H: 640,
      dprMax: 3
    },
    colors: {
      BRAND: "#9B7DD4",
      HOTPINK: "#FF2DAA"
    },
    assets: {
      TITLE_IMG_URL: "https://cdn.shopify.com/s/files/1/0731/1038/8969/files/fly-borahaem-title2.png?v=1768963386",
      GIF_URL: "https://cdn.shopify.com/s/files/1/0731/1038/8969/files/love-delivery-borahaem3.gif?v=1768966753",
      BGM_URL: "https://cdn.shopify.com/s/files/1/0731/1038/8969/files/004_BORAHAEM_Arcade.mp3?v=1768193007"
    },
    share: {
      title: "FLY! BORAHAEM",
      tryLine: "Try it : kimmddong.com > Playground > FLY! BORAHAEM",
      outW: 1080,
      outH: 1080
    },
    telemetry: {
      enabled: false,                    // 1차 배포는 false 권장 (서버 붙이면 true)
      endpoint: ""                       // 예: https://your-domain.com/api/game/event
    },
    uiLock: true,
    debug: false                         // true면 console 로그/내부값 확인용 확장 가능
  };

  const { BRAND, HOTPINK } = CONFIG.colors;

  const nameEl = $("lgName");
  const startBtn = $("lgFlyStart");
  const stepEl = $("lgStep1");


  /* =========================================================
   PATCH: Selected character applies to game + share image
   Put this inside fly-borahaem.js (near top, after CONFIG)
   ========================================================= */

  // 1) Same key as page2 selector script
  const LS_KEY_CHAR = "fly_borahaem_selected_char";

  // 2) Character GIF mapping (use your existing CDN urls)
  const CHAR_GIF = {
    "1": "https://cdn.shopify.com/s/files/1/0731/1038/8969/files/Character_01.gif?v=1769134933",
    "2": "https://cdn.shopify.com/s/files/1/0731/1038/8969/files/Character_02.gif?v=1769134939",
    "3": "https://cdn.shopify.com/s/files/1/0731/1038/8969/files/Character_03.gif?v=1769134944",
  };

  // optional: name map if you want alt/labels
  const CHAR_META = {
    "1": { name: "BORAHAEM", sub: "Blueberry" },
    "2": { name: "BUNHONGHAEM", sub: "Raspberry" },
    "3": { name: "X-HAEM", sub: "X-berry" },
  };

  function getSelectedCharId(){
    try{
      const v = localStorage.getItem(LS_KEY_CHAR);
      return (v === "2" || v === "3") ? v : "1";
    }catch(e){
      return "1";
    }
  }

  function getSelectedCharGifUrl(){
    const id = getSelectedCharId();
    return CHAR_GIF[id] || CHAR_GIF["1"];
  }

  // Keep a runtime cache (so we can refresh inside focus mode)
  let selectedCharIdCache = "1";
  let selectedCharGifCache = CHAR_GIF["1"];

  function refreshSelectedCharCache(){
    selectedCharIdCache = getSelectedCharId();
    selectedCharGifCache = getSelectedCharGifUrl();
  }

  // Call once on load
  refreshSelectedCharCache();

  // =========================================================
  // 1) UI lock (우클릭/선택/복사 방지 - input 제외)
  // =========================================================
  if(CONFIG.uiLock){
    (function lockInteractions(root){
      if(!root) return;

      const style = document.createElement("style");
      style.textContent = `
        #loveGame, #loveGame * { -webkit-user-select:none; user-select:none; }
        #loveGame input, #loveGame textarea { -webkit-user-select:text; user-select:text; }
        #loveGame button { -webkit-tap-highlight-color: rgba(0,0,0,0); outline:none; }
      `;
      document.head.appendChild(style);

      const block = (e) => {
        const t = e.target;
        if(t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA")) return;
        e.preventDefault();
        e.stopPropagation();
      };

      root.addEventListener("contextmenu", block, {capture:true});
      root.addEventListener("dragstart", block, {capture:true});
      root.addEventListener("selectstart", block, {capture:true});
      root.addEventListener("copy", block, {capture:true});
      root.addEventListener("cut", block, {capture:true});
    })($("loveGame"));
  }

  // =========================================================
  // 2) sanitize + name cache
  // =========================================================
  const sanitize = (s) => {
    s = (s || "").trim().slice(0, 24);
    s = s.replace(/[\u0000-\u001F\u007F]/g, "");
    s = s.replace(/[<>]/g, "");
    return s;
  };

  let syncing = false;
  function syncName(){
    if(syncing || !nameEl) return;
    syncing = true;
    nameEl.value = sanitize(nameEl.value);
    syncing = false;
    cacheWhoText();
  }
  nameEl && nameEl.addEventListener("input", syncName);
  nameEl && nameEl.addEventListener("blur", syncName);

  function hasName(){
    return !!sanitize(nameEl && nameEl.value);
  }

  let whoCache = "kimmddong";
  let whoLineCache = "I love you, kimmddong";
  function cacheWhoText(){
    const s = sanitize(nameEl && nameEl.value);
    whoCache = s ? s : "kimmddong";
    whoLineCache = "I love you, " + whoCache;
  }
  cacheWhoText();

  // =========================================================
  // 3) Step1 blink (only line1)
  // =========================================================
  let blinkTimer = null;
  let blinkPhase = 0;

  function renderStepLine1(color){
    if(!stepEl) return;
    const line1 = `<span style="color:${color};font-weight:900;text-shadow:0 2px 10px rgba(0,0,0,.12);">1. Type the name of someone you love</span>`;
    stepEl.innerHTML =
      `${line1}<br>` +
      `2. Hold FLY to go up<br>` +
      `3. Release to fall — collect hearts for bonus!<br><br>`;
  }

  function renderStepNormal(){
    if(!stepEl) return;
    stepEl.innerHTML =
      `1. Type the name of someone you love<br>` +
      `2. Hold FLY to go up<br>` +
      `3. Release to fall — collect hearts for bonus!<br><br>`;
  }

  function startBlink(){
    if(blinkTimer) return;
    blinkPhase = 0;
    renderStepLine1(HOTPINK);
    blinkTimer = setInterval(() => {
      blinkPhase++;
      renderStepLine1((blinkPhase % 2) ? BRAND : HOTPINK);
    }, 520);
  }

  function stopBlink(){
    if(blinkTimer){
      clearInterval(blinkTimer);
      blinkTimer = null;
    }
    blinkPhase = 0;
    renderStepNormal();
  }

  nameEl && nameEl.addEventListener("input", () => {
    const v = sanitize(nameEl.value);
    if(v) stopBlink();
  });

  // =========================================================
  // 4) Telemetry (play count, share count, etc) - optional
  // =========================================================
  function getAnonUserId(){
    try{
      const k = "borahaem_uid";
      let v = localStorage.getItem(k);
      if(!v){
        v = (crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + "_" + Math.random().toString(16).slice(2);
        localStorage.setItem(k, v);
      }
      return v;
    }catch(e){
      return "no_ls";
    }
  }

  function logEvent(type, payload){
    try{
      if(!CONFIG.telemetry.enabled) return;
      if(!CONFIG.telemetry.endpoint) return;

      const body = {
        type,
        ts: Date.now(),
        userId: getAnonUserId(),
        payload: payload || {}
      };

      fetch(CONFIG.telemetry.endpoint, {
        method: "POST",
        headers: {"content-type":"application/json"},
        body: JSON.stringify(body),
        keepalive: true
      }).catch(()=>{});
    }catch(e){}
  }

  // =========================================================
  // 5) Audio (BGM + SFX)
  // =========================================================
  const bgm = new Audio();
  bgm.loop = true;
  bgm.preload = "auto";
  bgm.volume = 0.19;
  let bgmReady = false;

  function initBgm(){
    if(bgmReady) return;
    bgm.src = CONFIG.assets.BGM_URL;
    bgmReady = true;
  }

  async function playBgm(){
    try { initBgm(); await bgm.play(); } catch(e) {}
  }

  function stopBgm(){
    try { bgm.pause(); } catch(e) {}
  }

  let sfxCtx;
  function getSfxCtx(){
    sfxCtx = sfxCtx || new (window.AudioContext || window.webkitAudioContext)();
    return sfxCtx;
  }

  function resumeAudio(){
    try{
      const c = getSfxCtx();
      c.resume && c.resume();
    }catch(e){}
  }

  function oscSfx({type, f0, f1, t1, f2, t2, gainPeak, dur, wave}){
    try{
      const c = getSfxCtx();
      const now = c.currentTime;
      const o = c.createOscillator();
      const g = c.createGain();

      o.type = wave || "sine";
      o.frequency.setValueAtTime(f0, now);
      if(f1 && t1) o.frequency.exponentialRampToValueAtTime(f1, now + t1);
      if(f2 && t2) o.frequency.exponentialRampToValueAtTime(f2, now + t2);

      g.gain.setValueAtTime(0.0001, now);
      g.gain.exponentialRampToValueAtTime(gainPeak || 0.6, now + 0.01);
      g.gain.exponentialRampToValueAtTime(0.0001, now + (dur || 0.16));

      o.connect(g);
      g.connect(c.destination);
      o.start(now);
      o.stop(now + (dur || 0.16));
    }catch(e){}
  }

  function sfxPop(){
    oscSfx({ f0: 990, f1: 220, t1: 0.10, gainPeak: 1.10, dur: 0.12, wave: "triangle" });
  }
  function sfxReFly(){
    oscSfx({ f0: 220, f1: 880, t1: 0.10, f2: 660, t2: 0.16, gainPeak: 0.45, dur: 0.20, wave: "square" });
  }
  function sfxGameOver(){
    try{
      const c = getSfxCtx();
      const now = c.currentTime;

      const o1 = c.createOscillator();
      const g1 = c.createGain();
      o1.type = "sine";
      o1.frequency.setValueAtTime(520, now);
      o1.frequency.exponentialRampToValueAtTime(220, now + 0.22);
      g1.gain.setValueAtTime(0.0001, now);
      g1.gain.exponentialRampToValueAtTime(0.55, now + 0.01);
      g1.gain.exponentialRampToValueAtTime(0.0001, now + 0.26);
      o1.connect(g1); g1.connect(c.destination);
      o1.start(now); o1.stop(now + 0.28);

      const o2 = c.createOscillator();
      const g2 = c.createGain();
      o2.type = "triangle";
      o2.frequency.setValueAtTime(330, now + 0.06);
      o2.frequency.exponentialRampToValueAtTime(165, now + 0.26);
      g2.gain.setValueAtTime(0.0001, now + 0.06);
      g2.gain.exponentialRampToValueAtTime(0.35, now + 0.08);
      g2.gain.exponentialRampToValueAtTime(0.0001, now + 0.30);
      o2.connect(g2); g2.connect(c.destination);
      o2.start(now + 0.06); o2.stop(now + 0.32);
    }catch(e){}
  }

  // =========================================================
  // 6) Toast
  // =========================================================
  function toast(msg){
    try{
      const el = document.createElement("div");
      el.textContent = msg;
      el.style.cssText = `
        position:fixed; left:50%; bottom:24px; transform:translateX(-50%);
        padding:10px 12px; border-radius:12px;
        background:rgba(10,10,18,.85); color:#fff; z-index:2147483647;
        font-weight:800; font-size:12px; border:1px solid rgba(255,255,255,.14);
        backdrop-filter: blur(10px);
      `;
      document.body.appendChild(el);
      setTimeout(()=>{ el.style.opacity="0"; el.style.transition="opacity .2s ease"; }, 1200);
      setTimeout(()=>{ el.remove(); }, 1500);
    }catch(e){}
  }

  // =========================================================
  // 7) Helpers: images + round rect
  // =========================================================
  function loadImage(url){
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error("Image load failed"));
      img.src = url;
    });
  }

  function roundRect(c, x, y, w, h, r){
    c.beginPath();
    c.moveTo(x+r, y);
    c.arcTo(x+w, y, x+w, y+h, r);
    c.arcTo(x+w, y+h, x, y+h, r);
    c.arcTo(x, y+h, x, y, r);
    c.arcTo(x, y, x+w, y, r);
    c.closePath();
  }

  // =========================================================
  // 8) Focus overlay + game objects
  // =========================================================
  let focusOn = false;
  let focusLayer = null;
  let gameWrap = null;

  let cv = null;
  let ctx = null;
  let dpr = 1;

  let gifEl = null;

  let flyBtn = null;
  let reFlyBtn = null;
  let shareBtn = null;
  let homeBtn = null;  

  let hudScoreEl = null;
  let hudHeartsEl = null;

  let overCard = null;
  let overScoreValueEl = null;
  let overMetaEl = null;

  // game state
  const gs = {
    t: 0,
    state: "idle",
    hold: false,
    dist: 0,
    score: 0,
    hearts: 0,
    items: [],
    planets: [],
    startedAt: 0
  };

  const BORAHAM_W = 108;
  const BORAHAM_H = 108;

  const CFG = {
    g: 0.38,
    flap: 0.95,
    maxUp: -6.8,
    maxDown: 8.4,
    speed: 2.05,
    heartEvery: 150,
    planetEvery: 240,
    bottomBoost: 3.0,
    planetRMin: 58,
    planetRMax: 92,
    safeTime: 900
  };

  const player = {
    x: 92,
    y: 0,
    vy: 0,
    r: Math.min(BORAHAM_W, BORAHAM_H) * 0.22
  };

  function W(){ return CONFIG.game.W; }
  function H(){ return CONFIG.game.H; }

  function applyCanvasDPR(){
    if(!cv || !ctx) return;
    dpr = Math.max(1, Math.min(CONFIG.game.dprMax, window.devicePixelRatio || 1));
    cv.width = Math.round(W() * dpr);
    cv.height = Math.round(H() * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function syncGifToPlayer(){
    if(!gifEl || !cv) return;
    const rect = cv.getBoundingClientRect();
    const s = Math.min(rect.width / W(), rect.height / H());
    const bob = (gs.state === "play") ? (Math.sin(gs.t*0.12) * 1.6) : 0;

    const gx = (player.x - BORAHAM_W/2) * s;
    const gy = (player.y - BORAHAM_H/2 + bob) * s;

    gifEl.style.transform = `translate(${gx}px, ${gy}px)`;
    gifEl.style.width = (BORAHAM_W * s) + "px";
    gifEl.style.height = (BORAHAM_H * s) + "px";
    gifEl.style.opacity = "1";
  }

  let starsA = [];
  let starsB = [];

  function initStars(){
    starsA = Array.from({length: 90}, () => ({
      x: Math.random()*W(), y: Math.random()*H(), r: 0.6 + Math.random()*1.4, a: 0.20 + Math.random()*0.55, s: 0.45 + Math.random()*1.15
    }));
    starsB = Array.from({length: 120}, () => ({
      x: Math.random()*W(), y: Math.random()*H(), r: 0.5 + Math.random()*1.0, a: 0.10 + Math.random()*0.35, s: 0.18 + Math.random()*0.55
    }));
  }

  function drawSpace(){
    const g = ctx.createLinearGradient(0,0,0,H());
    g.addColorStop(0, "#05050b");
    g.addColorStop(0.55, "#0b0b1a");
    g.addColorStop(1, "#1a1240");
    ctx.fillStyle = g;
    ctx.fillRect(0,0,W(),H());

    function glow(x,y,rad,alpha,rgb){
      const rg = ctx.createRadialGradient(x,y,0,x,y,rad);
      rg.addColorStop(0, `rgba(${rgb[0]},${rgb[1]},${rgb[2]},${alpha})`);
      rg.addColorStop(1, `rgba(${rgb[0]},${rgb[1]},${rgb[2]},0)`);
      ctx.fillStyle = rg;
      ctx.beginPath();
      ctx.arc(x,y,rad,0,Math.PI*2);
      ctx.fill();
    }
    glow(W()*0.22, H()*0.28, 240, 0.16, [155,125,212]);
    glow(W()*0.82, H()*0.56, 280, 0.10, [120,200,255]);
    glow(W()*0.55, H()*0.82, 260, 0.09, [255,170,220]);

    for(const s of starsB){
      s.x -= 0.12 * s.s;
      if(s.x < -2){ s.x = W()+2; s.y = Math.random()*H(); }
      const tw = 0.05 + 0.05*Math.sin((gs.t*0.03) + s.y*0.02);
      ctx.fillStyle = `rgba(255,255,255,${Math.max(0, Math.min(1, s.a + tw))})`;
      ctx.fillRect(s.x, s.y, s.r, s.r);
    }

    for(const s of starsA){
      s.x -= 0.28 * s.s;
      if(s.x < -2){ s.x = W()+2; s.y = Math.random()*H(); }
      const tw = 0.10 + 0.10*Math.sin((gs.t*0.05) + s.x*0.01);
      ctx.fillStyle = `rgba(255,255,255,${Math.max(0, Math.min(1, s.a + tw))})`;
      ctx.fillRect(s.x, s.y, s.r, s.r);
    }
  }

  function hitCircle(ax,ay,ar, bx,by,br){
    const dx = ax-bx, dy = ay-by;
    const rr = ar+br;
    return (dx*dx + dy*dy) <= rr*rr;
  }

  function drawHeart(x,y,scale){
    ctx.save();
    ctx.translate(x,y);
    ctx.scale(scale,scale);
    ctx.beginPath();
    ctx.moveTo(0, 10);
    ctx.bezierCurveTo(-18, -2, -10, -18, 0, -8);
    ctx.bezierCurveTo(10, -18, 18, -2, 0, 10);
    ctx.closePath();
    ctx.fillStyle = "rgba(255,255,255,0.88)";
    ctx.fill();
    ctx.strokeStyle = "rgba(155,125,212,0.78)";
    ctx.lineWidth = 2;
    ctx.stroke();
    ctx.restore();
  }

  function drawPlanet(pl){
    const cr = pl.c[0], cg = pl.c[1], cb = pl.c[2];
    const glow = ctx.createRadialGradient(pl.x,pl.y,pl.r*0.2, pl.x,pl.y,pl.r*1.25);
    glow.addColorStop(0, `rgba(${cr},${cg},${cb},0.22)`);
    glow.addColorStop(1, `rgba(${cr},${cg},${cb},0)`);
    ctx.fillStyle = glow;
    ctx.beginPath(); ctx.arc(pl.x,pl.y,pl.r*1.25,0,Math.PI*2); ctx.fill();

    const body = ctx.createRadialGradient(pl.x - pl.r*0.25, pl.y - pl.r*0.25, pl.r*0.1, pl.x,pl.y,pl.r);
    body.addColorStop(0, `rgba(${Math.min(255,cr+60)},${Math.min(255,cg+60)},${Math.min(255,cb+60)},0.95)`);
    body.addColorStop(1, `rgba(${cr},${cg},${cb},0.92)`);
    ctx.fillStyle = body;
    ctx.beginPath(); ctx.arc(pl.x,pl.y,pl.r,0,Math.PI*2); ctx.fill();

    ctx.strokeStyle = "rgba(255,255,255,0.22)";
    ctx.lineWidth = 3;
    ctx.beginPath();
    ctx.ellipse(pl.x, pl.y, pl.r*1.25, pl.r*0.45, -0.35, 0, Math.PI*2);
    ctx.stroke();
  }

  function spawnHeart(){
    const y = Math.floor(110 + Math.random()*(H() - 220));
    gs.items.push({ x: W() + 40, y: y, r: 14, taken:false });
  }

  function spawnPlanet(mode){
    const r = CFG.planetRMin + Math.random()*(CFG.planetRMax - CFG.planetRMin);
    const x = W() + r + 60;

    const pick = mode || (Math.random() < 0.34 ? "top" : (Math.random() < 0.52 ? "bottom" : "center"));
    let y;
    if(pick === "top") y = -r*0.35 + Math.random()*70;
    else if(pick === "bottom") y = H() + r*0.35 - Math.random()*70;
    else {
      const bandTop = H()*0.22, bandBot = H()*0.78;
      y = bandTop + Math.random()*(bandBot - bandTop);
    }

    const palette = [[155,125,212],[120,200,255],[255,170,220],[210,210,255]];
    const c = palette[Math.floor(Math.random()*palette.length)];
    gs.planets.push({ x:x, y:y, r:r, c:c });
  }

  function updateHud(){
    if(hudScoreEl) hudScoreEl.textContent = String(gs.score);
    if(hudHeartsEl) hudHeartsEl.textContent = String(gs.hearts);
  }

  function showGameOverCard(){
    if(!overCard) return;
    overCard.style.display = "block";
    const titleEl = overCard.firstChild;
    if(titleEl && titleEl.nodeType === 1){
      titleEl.textContent = whoCache + "! I love you this much: ";
    }
    if(overScoreValueEl) overScoreValueEl.textContent = String(gs.score);
    if(overMetaEl) overMetaEl.textContent = "Distance " + Math.floor(gs.dist) + " m  •  Hearts " + gs.hearts;
  }

  function hideGameOverCard(){
    if(!overCard) return;
    overCard.style.display = "none";
  }

  function setGameOver(){
    if(gs.state === "over") return;
    gs.state = "over";
    stopBgm();
    sfxGameOver();

    logEvent("play_end", { score: gs.score, dist: Math.floor(gs.dist), hearts: gs.hearts });

    if(flyBtn){
      flyBtn.style.opacity = "0.35";
      flyBtn.style.pointerEvents = "none";
      flyBtn.style.filter = "grayscale(35%)";
    }
    showGameOverCard();
    updateHud();
  }

  function resetToIdle(){
    gs.state = "idle";
    gs.hold = false;
    gs.dist = 0;
    gs.score = 0;
    gs.hearts = 0;
    gs.items = [];
    gs.planets = [];
    player.y = H() * 0.45;
    player.vy = 0;
    updateHud();
    hideGameOverCard();
    syncGifToPlayer();
  }

  function startPlay(){
    gs.state = "play";
    gs.hold = false;
    gs.dist = 0;
    gs.score = 0;
    gs.hearts = 0;
    gs.items = [];
    gs.planets = [];
    player.y = H() * 0.45;
    player.vy = 0;
    gs.startedAt = performance.now();
    updateHud();

    logEvent("play_start", { name: whoCache });
  }

  // =========================================================
  // 9) Share image (image-only)
  // =========================================================
  function drawTextTrackingStable(ctx, text, centerX, y, trackingPx, font, fillStyle){
    ctx.save();
    ctx.font = font;
    ctx.fillStyle = fillStyle;
    ctx.textAlign = "left";
    ctx.textBaseline = "alphabetic";

    const chars = Array.from(text);
    const widths = chars.map(ch => ctx.measureText(ch).width);

    const total = widths.reduce((a,b)=>a+b,0) + trackingPx * Math.max(0, chars.length - 1);
    let x = centerX - total/2;

    x = Math.round(x);
    y = Math.round(y);

    for(let i=0;i<chars.length;i++){
      ctx.fillText(chars[i], x, y);
      x += widths[i] + trackingPx;
      x = Math.round(x);
    }
    ctx.restore();
  }

  async function makeShareImageFile(){
    if(!cv) return null;

    const OUT_W = CONFIG.share.outW;
    const OUT_H = CONFIG.share.outH;

    const out = document.createElement("canvas");
    out.width = OUT_W;
    out.height = OUT_H;
    const octx = out.getContext("2d");

    // 배경: cv를 cover로 크롭
    const srcW = cv.width;
    const srcH = cv.height;
    const dstAspect = OUT_W / OUT_H;
    const srcAspect = srcW / srcH;

    let cropW, cropH, cx, cy;
    if(srcAspect > dstAspect){
      cropH = srcH;
      cropW = srcH * dstAspect;
      cx = (srcW - cropW) / 2;
      cy = 0;
    } else {
      cropW = srcW;
      cropH = srcW / dstAspect;
      cx = 0;
      cy = (srcH - cropH) / 2;
    }

    octx.drawImage(cv, cx, cy, cropW, cropH, 0, 0, OUT_W, OUT_H);
    octx.fillStyle = "rgba(0,0,0,0.08)";
    octx.fillRect(0, 0, OUT_W, OUT_H);

    // 상단 타이틀 이미지
    const topMargin = 32;
    const titleY = topMargin;
    let titleBottomY = titleY + 86;

    // 수정후 (좌우 150px 여백 고정: 총 300px / 즉 최대폭 = OUT_W - 300)
    // ✅ 수정후 (좌우 150px 여백 고정 + 업스케일 허용)
    try{
      const titleImg = await loadImage(CONFIG.assets.TITLE_IMG_URL);
    
    const SIDE_PAD = 150;
    const maxW = OUT_W - (SIDE_PAD * 2);     // 1080 - 300 = 780
    
    const scale = maxW / titleImg.width;     // ✅ Math.min(1, ...) 제거 = 업스케일 허용
    const tw = Math.round(titleImg.width * scale); // 결과: 500 -> 780
    const th = Math.round(titleImg.height * scale);
    
    const tx = Math.round((OUT_W - tw) / 2); // 또는 tx = SIDE_PAD; (둘 다 결과 동일)
    octx.drawImage(titleImg, tx, Math.round(titleY), tw, th);
    
      titleBottomY = titleY + th;
    }catch(e){}

    // score card 위치
    const cardW = 860;
    const cardH = 350;
    const cardX = (OUT_W - cardW) / 2;

    const topSafe = Math.round(titleBottomY + 56);
    const bottomSafe = OUT_H - 220;

    let cardY = Math.round((topSafe + bottomSafe - cardH) / 2);
    cardY = Math.max(topSafe, Math.min(cardY, OUT_H - cardH - 220));

    octx.save();
    octx.fillStyle = "rgba(10,10,18,0.62)";
    roundRect(octx, cardX, cardY, cardW, cardH, 44);
    octx.fill();

    octx.strokeStyle = "rgba(255,255,255,0.14)";
    octx.lineWidth = 4;
    roundRect(octx, cardX, cardY, cardW, cardH, 44);
    octx.stroke();
    octx.restore();

    // 캐릭터
    const charW = 220;
    const charH = 220;
    const charX = cardX + 56;
    const charY = cardY + (cardH/2) - (charH/2);

    try{
      //const img = await loadImage(CONFIG.assets.GIF_URL);
      
      // ensure 최신 선택값 반영
      refreshSelectedCharCache();
      const img = await loadImage(selectedCharGifCache);

      octx.drawImage(img, Math.round(charX), Math.round(charY), charW, charH);
    }catch(e){}

    // 카드 텍스트
    const right = cardX + cardW - 56;
    octx.textAlign = "right";
    octx.textBaseline = "alphabetic";

    let ty = cardY + 78;

    octx.fillStyle = "#fff";
    octx.font = "900 44px system-ui, -apple-system, Segoe UI, Roboto, Arial";
    octx.fillText(whoCache + "!", right, Math.round(ty));

    ty += 50;
    octx.fillStyle = "rgba(255,255,255,0.88)";
    octx.font = "900 40px system-ui, -apple-system, Segoe UI, Roboto, Arial";
    octx.fillText("I love you this much:", right, Math.round(ty));

    ty += 132;
    octx.fillStyle = BRAND;
    octx.font = "900 140px system-ui, -apple-system, Segoe UI, Roboto, Arial";
    octx.fillText(String(gs.score), right, Math.round(ty));

    ty += 44;
    octx.fillStyle = "rgba(255,255,255,0.84)";
    octx.font = "800 34px system-ui, -apple-system, Segoe UI, Roboto, Arial";
    octx.fillText("Distance " + Math.floor(gs.dist) + " m  •  Hearts " + gs.hearts, right, Math.round(ty));

    // Try it
    const tryY = cardY + cardH + 44;
    octx.textAlign = "center";
    octx.textBaseline = "alphabetic";
    octx.fillStyle = "rgba(255,255,255,0.80)";
    octx.font = "800 28px system-ui, -apple-system, Segoe UI, Roboto, Arial";
    octx.fillText(CONFIG.share.tryLine, OUT_W/2, Math.round(tryY));

    // 하단 2줄 (위로 올린 버전)
    const bottomMargin = 78;
    const instaY = OUT_H - bottomMargin - 12;
    const copyY  = OUT_H - bottomMargin + 18;

    drawTextTrackingStable(
      octx,
      "instagram : @kimmddong",
      OUT_W/2,
      instaY,
      1.8,
      "800 26px system-ui, -apple-system, Segoe UI, Roboto, Arial",
      "rgba(255,255,255,0.72)"
    );

    drawTextTrackingStable(
      octx,
      "Copyright © 2022-2026 kimmddong. All Rights Reserved.",
      OUT_W/2,
      copyY,
      1.3,
      "800 24px system-ui, -apple-system, Segoe UI, Roboto, Arial",
      "rgba(255,255,255,0.66)"
    );

    const blob = await new Promise(r => out.toBlob(r, "image/png", 0.92));
    if(!blob) return null;
    return new File([blob], "fly-borahaem-score.png", { type:"image/png" });
  }

  // =========================================================
  // 10) Main loop
  // =========================================================
  function loop(){
    if(!cv || !ctx) return;
    gs.t++;

    // 논리좌표 기준 클리어 (DPR transform 적용 상태)
    ctx.clearRect(0, 0, W(), H());

    drawSpace();


    if(gs.state === "play"){
      if(gs.hold){
        player.vy -= CFG.flap;
        if(player.vy < CFG.maxUp) player.vy = CFG.maxUp;
      } else {
        player.vy += CFG.g;
        if(player.vy > CFG.maxDown) player.vy = CFG.maxDown;
      }
      player.y += player.vy;

      if(player.y < 26){ player.y = 26; player.vy = 0.8; }
      if(player.y > H() - 24){ player.y = H() - 24; player.vy = -1.6; }

      gs.dist += CFG.speed * 0.065;

      if(gs.t % CFG.heartEvery === 0) spawnHeart();
      if(gs.t % CFG.planetEvery === 0) spawnPlanet();
      if(Math.random() < ((1 / CFG.planetEvery) * CFG.bottomBoost)) spawnPlanet("bottom");

      for(const it of gs.items) it.x -= CFG.speed;
      for(const pl of gs.planets) pl.x -= CFG.speed;

      gs.items = gs.items.filter(it => it.x > -60 && !it.taken);
      gs.planets = gs.planets.filter(pl => pl.x > -pl.r*2);

      const inGrace = (performance.now() - gs.startedAt) < CFG.safeTime;

      for(const it of gs.items){
        if(!it.taken && hitCircle(player.x, player.y, player.r, it.x, it.y, it.r)){
          it.taken = true;
          gs.hearts += 1;
          gs.score += 220;
          sfxPop();
        }
      }

      // ✅ 최종 점수 보정을 먼저 확정 (HUD/게임오버/공유 점수 통일)
      gs.score = Math.max(gs.score, Math.floor(gs.dist*10) + gs.hearts*220);
      
      if(!inGrace){
        for(const pl of gs.planets){
          if(hitCircle(player.x, player.y, player.r, pl.x, pl.y, pl.r*0.92)){
            setGameOver();
            break;
          }
        }
      }

      updateHud();
    } else {
      updateHud();
    }

    for(const pl of gs.planets) drawPlanet(pl);
    for(const it of gs.items){
      const pulse = 1 + 0.08*Math.sin(gs.t*0.12 + it.y*0.02);
      drawHeart(it.x, it.y, pulse);
    }

    syncGifToPlayer();
    requestAnimationFrame(loop);
  }

  // =========================================================
  // 11) Controls (bound once per focus session)
  // =========================================================
  let controlsBound = false;
  function bindControls(){
    if(!flyBtn || controlsBound) return;
    controlsBound = true;

    function setPressed(on){
      if(!flyBtn) return;
      if(on){
        flyBtn.style.filter = "brightness(0.92)";
        flyBtn.style.transform = "scale(0.97)";
      } else {
        flyBtn.style.filter = "";
        flyBtn.style.transform = "";
      }
    }

    function onHoldStart(e){
      e.preventDefault();
      resumeAudio();

      if(gs.state === "over") return;

      playBgm();

      if(gs.state === "idle"){
        startPlay();
        gs.hold = true;
        setPressed(true);
        return;
      }
      gs.hold = true;
      setPressed(true);
    }

    function onHoldEnd(e){
      e.preventDefault();
      gs.hold = false;
      setPressed(false);
    }

    flyBtn.addEventListener("pointerdown", onHoldStart);
    window.addEventListener("pointerup", onHoldEnd);
    window.addEventListener("pointercancel", onHoldEnd);

    window.addEventListener("resize", () => {
      applyCanvasDPR();
      syncGifToPlayer();
    });
  }

  // =========================================================
  // 12) Focus mode (overlay)
  // =========================================================
  function enterFocusMode(){
    if(focusOn) return;
    focusOn = true;

    logEvent("game_open", { name: whoCache });

    focusLayer = document.createElement("div");
    focusLayer.style.cssText = `
      position:fixed; inset:0; z-index:2147483000;
      background:rgba(5,5,12,0.94);
      display:flex; align-items:center; justify-content:center;
      padding:10px;
      overscroll-behavior:contain;
      touch-action:none;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
    `;

    const box = document.createElement("div");
    box.style.cssText = `
      width:min(520px, 100%);
      height:92vh;
      display:flex;
      flex-direction:column;
      gap:10px;
    `;

    const top = document.createElement("div");
    top.style.cssText = `display:flex; align-items:center; justify-content:space-between; color:#fff; opacity:.92;`;

    const title = document.createElement("div");
    title.textContent = "FLY! BORAHAEM";
    title.style.cssText = "font-weight:900;font-size:14px;";

    const exitBtn = document.createElement("button");
    exitBtn.type = "button";
    exitBtn.textContent = "Exit";
    exitBtn.style.cssText = `
      border:1px solid rgba(255,255,255,.18);
      background:transparent; color:#fff;
      padding:8px 10px; border-radius:12px;
      font-weight:900; cursor:pointer;
      outline:none;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
    `;
    exitBtn.addEventListener("click", exitFocusMode);
    exitBtn.addEventListener("contextmenu", (e)=>e.preventDefault());

    top.appendChild(title);
    top.appendChild(exitBtn);

    gameWrap = document.createElement("div");
    gameWrap.style.cssText = `
      position:relative;
      flex:1;
      border-radius:16px;
      overflow:hidden;
      border:1px solid rgba(255,255,255,.12);
      background:#06060b;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
    `;

    // canvas (DPR + logical coord)
    cv = document.createElement("canvas");
    cv.style.cssText = "width:100%;height:100%;display:block;";
    ctx = cv.getContext("2d", { alpha: true });
    applyCanvasDPR();
    gameWrap.appendChild(cv);

    // overlay gif (logical -> CSS scale)
    gifEl = document.createElement("img");
    gifEl.alt = "BORAHAM";
    gifEl.crossOrigin = "anonymous";

    // just before creating gifEl (or right before setting src)    
    refreshSelectedCharCache();
    gifEl.src = selectedCharGifCache;
    // optional 
    // gifEl.src = CONFIG.assets.GIF_URL;
    gifEl.alt = (CHAR_META[selectedCharIdCache]?.name || gifEl.alt);

    gifEl.style.cssText = `
      position:absolute;left:0;top:0;
      width:${BORAHAM_W}px;height:${BORAHAM_H}px;
      object-fit:contain;
      transform:translate(0px,0px);
      pointer-events:none;
      z-index:3;
    `;
    gameWrap.appendChild(gifEl);

    // ✅ 추가 (DOM 오버레이로 또렷하게)
    let whoLabelEl = null;   // 파일 상단 변수들 있는 곳에 같이 두면 더 깔끔 (없으면 enterFocusMode 안에만 둬도 OK)

    whoLabelEl = document.createElement("div");
    whoLabelEl.textContent = whoLineCache;
    whoLabelEl.style.cssText = `
      position:absolute;
      left:14px;
      top:14px;
      z-index:6;
      color:rgba(255,255,255,0.92);
      font:700 14px system-ui, -apple-system, Segoe UI, Roboto, Arial;
      text-shadow:0 2px 10px rgba(0,0,0,.35);
      pointer-events:none;
    `;
    gameWrap.appendChild(whoLabelEl);


    // HUD
    const hud = document.createElement("div");
    hud.style.cssText = `
      position:absolute;
      top:14px;
      right:14px;
      z-index:6;
      display:flex;
      gap:10px;
      padding:8px 10px;
      border-radius:12px;
      background:rgba(10,10,18,0.55);
      border:1px solid rgba(255,255,255,.14);
      color:#fff;
      font-size:12px;
      font-weight:900;
      backdrop-filter: blur(6px);
      pointer-events:none;
    `;
    hud.innerHTML = `
      <div>Score <span id="hudScore" style="color:${BRAND};">0</span></div>
      <div>♥ <span id="hudHearts">0</span></div>
    `;
    gameWrap.appendChild(hud);
    hudScoreEl = hud.querySelector("#hudScore");
    hudHeartsEl = hud.querySelector("#hudHearts");

    // FLY button
    flyBtn = document.createElement("button");
    flyBtn.type = "button";
    flyBtn.textContent = "FLY";
    flyBtn.style.cssText = `
      position:absolute;
      right: 14px;
      bottom: calc(24px + 96px + env(safe-area-inset-bottom, 0px));
      width:84px;
      height:84px;
      border-radius:999px;
      border:1px solid rgba(255,255,255,.14);
      background:${BRAND};
      color:#fff;
      font-weight:900;
      font-size:16px;
      cursor:pointer;
      user-select:none;
      outline:none;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
      box-shadow:0 12px 28px rgba(0,0,0,.38);
      touch-action:none;
      transition: transform .06s ease, filter .06s ease, opacity .12s ease;
      z-index:5;
    `;
    flyBtn.addEventListener("focus", ()=>flyBtn.blur());
    flyBtn.addEventListener("contextmenu", (e)=>e.preventDefault());
    gameWrap.appendChild(flyBtn);

    // hint
    const hint = document.createElement("div");
    hint.style.cssText = `
      position:absolute;left:12px;bottom: calc(14px + env(safe-area-inset-bottom, 0px));
      font-size:11px;opacity:.80;pointer-events:none;color:#fff;line-height:1.35;
      text-shadow:0 2px 10px rgba(0,0,0,.35);
      z-index:2;
    `;
    hint.innerHTML =
      `Hold FLY to go up. Release to fall.<br>` +
      `♫ BGM : BORAHAEM Arcade<br>` +
      `Copyright © 2022-2026 kimmddong. All Rights Reserved.`;
    gameWrap.appendChild(hint);

    // Game over card
    overCard = document.createElement("div");
    overCard.style.cssText = `
      position:absolute;
      left:16px;
      top:50%;
      transform:translateY(-50%);
      width:min(360px, calc(100% - 32px));
      padding:16px 16px 14px;
      border-radius:16px;
      background:rgba(10,10,18,0.55);
      border:1px solid rgba(255,255,255,.14);
      backdrop-filter: blur(10px);
      color:#fff;
      z-index:999;
      display:none;
      pointer-events:auto;
    `;

    const overTitle = document.createElement("div");
    overTitle.style.cssText = "font-weight:900;font-size:16px;opacity:.96;margin-bottom:10px;";
    overTitle.textContent = whoCache + "! I love you this much: ";

    overScoreValueEl = document.createElement("div");
    overScoreValueEl.textContent = "0";
    overScoreValueEl.style.cssText = `
      font-weight:900;
      font-size:52px;
      line-height:1;
      color:${BRAND};
      letter-spacing:0.5px;
      margin-bottom:10px;
    `;

    const btnRow = document.createElement("div");
    btnRow.style.cssText = "display:flex;gap:10px;flex-wrap:wrap;align-items:center;";

    // ✅ Home (add this before Share button creation)
    homeBtn = document.createElement("button");
    homeBtn.type = "button";
    homeBtn.textContent = "Home";
    homeBtn.style.cssText = `
      padding:10px 14px;
      border-radius:12px;
      border:1px solid rgba(255,255,255,.18);
      background:rgba(255,255,255,0.10);
      color:#fff;
      font-weight:900;
      cursor:pointer;
      user-select:none;
      outline:none;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
      box-shadow:0 10px 22px rgba(0,0,0,.18);
    `;
    homeBtn.addEventListener("contextmenu", (e)=>e.preventDefault());
    homeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      resumeAudio();
      logEvent("home_click", {});
      exitFocusMode();
      try { window.scrollTo({ top: 0, behavior: "smooth" }); } catch(e){}

      // (optional) go back to Page1
      const p1 = document.getElementById("lgPage1");
      const p2 = document.getElementById("lgPage2");
      if(p1) p1.style.display = "block";
      if(p2) p2.style.display = "none";
    });


    // Share (image only)
    shareBtn = document.createElement("button");
    shareBtn.type = "button";
    shareBtn.textContent = "Share";
    shareBtn.style.cssText = `
      padding:10px 14px;
      border-radius:12px;
      border:1px solid rgba(255,255,255,.18);
      background:rgba(255,255,255,0.10);
      color:#fff;
      font-weight:900;
      cursor:pointer;
      user-select:none;
      outline:none;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
      box-shadow:0 10px 22px rgba(0,0,0,.18);
    `;
    shareBtn.addEventListener("contextmenu", (e)=>e.preventDefault());
    shareBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      resumeAudio();

      logEvent("share_click", { score: gs.score });

      if(!navigator.share){
        toast("Sharing is not supported on this device 💜");
        return;
      }
      try{
        const file = await makeShareImageFile();
        if(file && navigator.canShare && navigator.canShare({ files: [file] })){
          await navigator.share({ files: [file], title: CONFIG.share.title });
          return;
        }
        toast("Sharing is not supported on this device 💜");
      }catch(err){
        toast("Share canceled 💜");
      }
    });

    // Re-FLY
    reFlyBtn = document.createElement("button");
    reFlyBtn.type = "button";
    reFlyBtn.textContent = "Re-FLY";
    reFlyBtn.style.cssText = `
      padding:10px 14px;
      border-radius:12px;
      border:1px solid rgba(255,255,255,.18);
      background:${BRAND};
      color:#fff;
      font-weight:900;
      cursor:pointer;
      user-select:none;
      outline:none;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
      box-shadow:0 10px 22px rgba(0,0,0,.28);
    `;
    reFlyBtn.addEventListener("contextmenu", (e)=>e.preventDefault());
    reFlyBtn.addEventListener("click", (e) => {
      e.preventDefault();
      resumeAudio();

      logEvent("refly_click", {});

      sfxReFly();
      startPlay();
      hideGameOverCard();

      if(flyBtn){
        flyBtn.style.opacity = "1";
        flyBtn.style.pointerEvents = "auto";
        flyBtn.style.filter = "";
      }

      gs.hold = true;
      setTimeout(()=>{ gs.hold = false; }, 120);
      playBgm();
    });

    
    btnRow.appendChild(homeBtn);
    btnRow.appendChild(shareBtn);
    btnRow.appendChild(reFlyBtn);

    overMetaEl = document.createElement("div");
    overMetaEl.style.cssText = "margin-top:10px;font-size:12px;opacity:.82;font-weight:700;";

    const overHint = document.createElement("div");
    overHint.textContent = "Share your score or Re-FLY to try again.";
    overHint.style.cssText = "margin-top:6px;font-size:12px;opacity:.78;font-weight:800;";

    overCard.appendChild(overTitle);
    overCard.appendChild(overScoreValueEl);
    overCard.appendChild(btnRow);
    overCard.appendChild(overMetaEl);
    overCard.appendChild(overHint);
    gameWrap.appendChild(overCard);

    // compose
    box.appendChild(top);
    box.appendChild(gameWrap);
    focusLayer.appendChild(box);
    document.body.appendChild(focusLayer);
    document.body.style.overflow = "hidden";

    focusLayer.addEventListener("contextmenu", (e)=>e.preventDefault(), {capture:true});

    // init
    initStars();
    resetToIdle();
    bindControls();

    // ensure clean state for this focus session
    controlsBound = false; // allow bindControls exactly once per session
    bindControls();

    // start loop
    requestAnimationFrame(loop);
    setTimeout(syncGifToPlayer, 0);
  }

  function exitFocusMode(){
    if(!focusOn) return;
    focusOn = false;

    stopBgm();

    try{
      document.body.style.overflow = "";
      focusLayer && focusLayer.remove();
    }catch(e){}

    // reset references
    focusLayer = null;
    gameWrap = null;
    cv = null;
    ctx = null;
    gifEl = null;

    flyBtn = null;
    reFlyBtn = null;
    shareBtn = null;    
    homeBtn = null;

    hudScoreEl = null;
    hudHeartsEl = null;

    overCard = null;
    overScoreValueEl = null;
    overMetaEl = null;

    // session flags
    controlsBound = false;
  }

  // =========================================================
  // 13) Start from page button
  // =========================================================
  function startFromPage(e){
    e.preventDefault();
    syncName();

    if(!hasName()){
      startBlink();
      try { nameEl && nameEl.focus(); } catch(e){}
      return;
    }

    stopBlink();
    enterFocusMode();
    playBgm();
    startPlay();

    gs.hold = true;
    setTimeout(()=>{ gs.hold = false; }, 120);
  }

  startBtn && startBtn.addEventListener("click", startFromPage);
  startBtn && startBtn.addEventListener("focus", ()=>startBtn.blur());

  window.addEventListener("beforeunload", stopBgm);

  // initial
  renderStepNormal();
  logEvent("page_view", {});

})();
